import './undecided-lines.css';

import { List } from '@kerfjs/ui/list';
import { ListHeader } from '@kerfjs/ui/list-header';
import { ListInsetControl } from '@kerfjs/ui/list-inset-control';
import { ListItem } from '@kerfjs/ui/list-item';
import { Row } from '@kerfjs/ui/row';
import { Text } from '@kerfjs/ui/text';
import { type SafeHtml } from 'kerfjs';

import type { SummaryLine } from './summary-context.js';

/** The lines still awaiting a decision, each linking back to the Line items screen. Renders nothing when there are none. */
export function UndecidedLines({ lines }: { lines: readonly SummaryLine[] }): SafeHtml {
  if (lines.length === 0) return <></>;
  return (
    <List dividerSides="t">
      <ListHeader label={`${lines.length} Line${lines.length === 1 ? '' : 's'} Still Undecided`} />
      <ListInsetControl sides="rl">
        <Text tone="quiet" size="compact">
          Decide {lines.length === 1 ? 'it' : 'them'} on the Line Items screen.
        </Text>
      </ListInsetControl>
      {lines.map((line) => (
        <ListItem
          data-key={line.id}
          multiline
          label={
            <Row vAlign="middle">
              <Text flush font="monospace" className="undecided-line-number">
                {line.lineNumber}.
              </Text>
              <a class="undecided-line-link" href="#" data-goto-line={line.id}>
                {line.description}
              </a>
            </Row>
          }
          action=""
        />
      ))}
    </List>
  );
}
